export const nomeclaturas = {
    CodigoCadastro: "Código Cadastro",
    DataFimVigencia: "Data de Fim Vigência",
    Status: "Status",
    NomeSolicitante: "Nome Solicitante",
    Email: "Email",
    CodigoSistemaPrefeitura: "Código Sistema Prefeitura",
    ProtocoloDestino: "Protocolo Destino",
    Cpf_Cnpj: "CPF/CNPJ",
    InscricaoMunicipal: "Inscrição Municipal",
    Nome_Fantasia: "Nome Fantasia",
    RazaoSocial: "Razão Social",
    NomeResponsavel: "Nome Responsável",
    NomeResponsavelTecnico: "Nome Responsável Técnico",
    TipoDocumentoResponsavelTecnico: "Tipo Documento Responsável Técnico",
    NumeroDocumentoResponsavelTecnico: "Número Documento Responsável Técnico",
    CCM: "CCM",
    CEP: "CEP",
    Logradouro: "Logradouro",
    NumEndereco: "Número",
    Complemento: "Complemento",
    Bairro: "Bairro",
    Cidade: "Cidade",
    Telefone: "Telefone",
    Celular: "Celular",
    RamoAtividade: "Ramo de Atividade",
    UF: "UF",
    TipoIndustriaComercio: "Tipo Indústria/Comércio",
    ProtocoloGerador: "Protocolo Gerador",
    GeoLocalizacao: "Geolocalização",
    Usuario: "Usuário",
    DataAlteracao: "Data Alteração",
    CNPJ: "CNPJ",
    NomeFantasia: "Nome Fantasia",
    SubPrefeitura: "Subprefeitura",
    Tipo: "Tipo",
    CapacidadeCarga: "Capacidade de Carga",
    Tara: "Tara",
    AnoFabricacao: "Ano de Fabricação",
    NumeroRenavam: "Número Renavam",
    ArquivoRenavam: "Arquivo Renavam",
    ArquivoRenavamBase64: "Arquivo Renavam",
    ArquivoInspecaoInmetro: "Arquivo Inspeção Inmetro",
    ArquivoInspecaoInmetroBase64: "Arquivo Inspeção Inmetro",
    ArquivoComprovanteTara: "Arquivo Comprovante Tara",
    ArquivoComprovanteTaraBase64: "Arquivo Comprovante Tara",
    ArquivoComodato: "Arquivo Comodato",
    ArquivoComodatoBase64: "Arquivo Comodato",
    DataVistoria: "Data de Vistoria",
    DataValidadeVistoria: "Data Validade Vistoria",
    AnoFabricacaoEquipamento: "Ano de Fabricação Equipamento",
    ProprietarioOuLocado: "Proprietário ou Locado",
    Cor: "Cor",
    Volume: "Volume",
    PlacaAntiga: "Placa Antiga",
    QuantidadeLeitosEstimada: "Quantidade Leitos Estimada",
    Descricao: "Descrição",
    UsuarioAlteracao: "Usuário de Alteração"
};
